/** "Dr. " + name, unless the stored name already starts with the title ("Dr. Rao", "dr rao"). */
export function withDr(name?: string | null): string {
  const n = (name ?? '').trim();
  if (!n) return '';
  return /^dr\b\.?/i.test(n) ? n : `Dr. ${n}`;
}
